const SESSION_STORAGE_KEYS = {
  INTRO_SHOWN: "intro-shown",
};

export function hasSeenIntro() {
  return (
    window.sessionStorage.getItem(SESSION_STORAGE_KEYS.INTRO_SHOWN) === "true"
  );
}

export function setHasSeenIntro() {
  window.sessionStorage.setItem(SESSION_STORAGE_KEYS.INTRO_SHOWN, "true");
}
